import { ACTION_TYPES, PepperReview } from './types';
import { Action } from 'modules/cm/store/cases/types';

export const storePepperReviewSuccess = (payload: PepperReview): Action => ({
  type: ACTION_TYPES.STORE_PEPPER_REVIEW_SUCCESS,
  payload: [payload, null],
});
